import { styled } from "styled-components";

import { CrossIcon, ImageBackground } from "common/components";
import { zIndex } from "common/constants/zIndex";
import { breakpoints, easing } from "common/styles";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { setAudioPlayer } from "domains/audioPlayer/actions";
import { AudioPlayer } from "domains/audioPlayer/components/AudioPlayer";
import { getAudioPlayerFile } from "domains/audioPlayer/selectors";

const Container = styled.div<{ isOpen: boolean }>`
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  bottom: 0;
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: fixed;
  width: 100%;

  @media ${breakpoints.medium} {
    border-radius: 5px;
    bottom: 2rem;
    box-shadow: ${({ theme }) => theme.shadows.box};
    display: block;
    left: 2rem;
    transform: translate3d(${({ isOpen }) => (isOpen ? 0 : -120)}%, 0, 0);
    transition: transform 0.3s ${easing.slightBounce};
    width: 450px;
    z-index: ${zIndex.audioPlayer};
  }
`;

const Content = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1rem;
`;

const Image = styled(ImageBackground)`
  border-radius: 5px;
  height: 6.25rem;
  overflow: hidden;
  width: 6.25rem;
`;

const Close = styled(CrossIcon)`
  color: ${({ theme }) => theme.colors.textFade};
  cursor: pointer;
  height: 1rem;
  inset: 1rem 1rem auto auto;
  position: absolute;
  transition: color 0.3s;
  width: 1rem;

  &:hover {
    color: ${({ theme }) => theme.colors.textBright};
  }
`;

export const AudioPlayerProvider = () => {
  const dispatch = useDispatch();
  const audioFile = useSelector(getAudioPlayerFile);

  return (
    <Container isOpen={!!audioFile}>
      {audioFile && (
        <Content>
          <Image src={audioFile.image} />
          <AudioPlayer audioFile={audioFile} />
          <Close onClick={() => dispatch(setAudioPlayer(undefined))} />
        </Content>
      )}
    </Container>
  );
};
